<template>
  <div id="footer" class="bg-grey">
    <div class="row content-container">
      <div class="col-12 col-md-6 spectrum-logo">
        <img src="/img/logo-spectrum-life.svg" />
      </div>
      <div class="col-12 col-md-6 copy-right">
        <p>© 2019 Spectrum.Life. All Rights Reserved.</p>
        <a
          href="https://www.spectrum.life/privacy-policy"
          target="_blank"
          class="privacy"
        >
          Privacy Policy
        </a>
        <a href="https://www.spectrum.life/data-consent/" target="_blank">
          Terms & Conditions
        </a>
        <div class="col-12 logout mt-2 pr-0">
          <a @click="logout()">Logout</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: "Footer",
  components: {},
  data() {
    return {};
  },
  mounted() {
  },
  methods: {
      logout(){
          this.$store.commit('logout');
          this.$router.push({name: 'login'})
      }
  },
    computed:{
    }
};
</script>
<style lang="less">
#footer {
  padding: 30px 0;
  text-align: center;
  .spectrum-logo {
    text-align: left;
    img {
      margin: auto;
      max-width: 250px;
      width: 100%;
      text-align: left;
    }
  }
  .copy-right {
    color: #727577;
    font-family: "FilsonProBook", sans-serif;
    font-size: 1.2rem;
    text-align: right;
    a {
      text-decoration: none;
      color: #727577;
    }
    .privacy {
      border-style: solid;
      border-width: 0 1px 0 0;
      border-color: #727577;
      padding: 0 3px 5px 0;
      margin-right: 5px;
    }
  }
  @media only screen and (max-width: 768px){
    .spectrum-logo {
      text-align: center;
      img {
        margin: auto;
        text-align: center;
      }
    }
    .copy-right {
      padding: 20px 0;
      text-align: center;
    }
  }
}
</style>
